import VoucherFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<VoucherFormLayout />} transformValues={transformValues} />
